import React, { useEffect } from 'react';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/Public/PublicHeader';
import PublicFooter from '../../components/Public/PublicFooter';
import TrustHubWidget from '../../components/Legal/TrustHubWidget';
import useSEO from '../../hooks/useSEO';
import seoService from '../../services/seo.service';
import { getLegalPublicBaseUrl } from '../../utils/legalPublicUrls';
/* STYLESYSTEM/pages/public-marketing.css */

const { Title } = Typography;

export default function TrustPage() {
  useSEO('trust', null, {
    title: 'Доверие и персональные данные — Markbase',
    description: 'Безопасность, документы 152-ФЗ, Privacy Center и сведения об операторе персональных данных.',
  });

  useEffect(() => {
    const base = getLegalPublicBaseUrl();
    seoService.injectJsonLd([
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Markbase',
        url: base,
        sameAs: [base],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'PrivacyPolicy',
        name: 'Политика конфиденциальности Markbase',
        url: `${base}/privacy`,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Доверие и персональные данные',
        url: `${base}/trust`,
        inLanguage: 'ru-RU',
      },
    ]);
    return () => seoService.removeJsonLd();
  }, []);

  return (
    <div className="public-page">
      <PublicHeader />
      <section className="page-hero">
        <div className="container">
          <Title level={1} style={{ marginBottom: 8 }}>
            Доверие и персональные данные
          </Title>
        </div>
      </section>
      <section className="content-section">
        <div className="container" style={{ maxWidth: 960 }}>
          <TrustHubWidget />
          <p style={{ marginTop: 32 }}>
            <Link to="/legal">Все правовые документы →</Link>
          </p>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
